<template>
   <div>
      <v-container>
         <v-toolbar dense color="primary white--text" bottom>
            <v-toolbar-title> Attendance: {{ event.event_date }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="indigo" class="white" outlined @click="goBack()">
               Back
            </v-btn>
         </v-toolbar>
         <v-row>
            <v-col cols="12">
               <v-card flat outlined>
                  <div class="ml-2 text-md-h6 text-xs-h6">
                     Group: {{ event.cca_name }} ({{ participants.length }}
                     <template v-if="$vuetify.breakpoint.mdAndUp">students</template>)
                  </div>
               </v-card>
            </v-col>
         </v-row>
         <div v-for="pcp in participants" :key="pcp.school_id">
            <attendance :student="pcp" @save-attend="updateAttendance" />
         </div>
      </v-container>
   </div>
</template>

<script>
   import attendance from "@/components/attendance";

   export default {
      props: {
         event: Object,
      },

      inject: ["ShowMessage"],

      components: {
         attendance: attendance,
      },
      data() {
         return {
            participants: [],
            eventid: this.event.event_id,
            ccaid: this.event.cca_id,
            eventdate: "",
            eventattendance: this.event,
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         async doLoadParticipant() {
            await this.$http({
               url: "/cca/geteventparticipant.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  eventid: this.event.event_id,
                  ccaid: this.event.cca_id,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.participants = response.data.participantdata;
               } else {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
               }
            });
         },

         async updateAttendance(studentattendance) {
            await this.$http({
               url: "/cca/saveattendance.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  eventid: this.eventid,
                  ccaid: this.ccaid,
                  schoolid: studentattendance.school_id,
                  attend: studentattendance.attend,
                  submitby: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
               }
            });
         },
      },
      mounted() {
         this.doLoadParticipant();
      },
   };
</script>
